import { useState, useMemo, useEffect } from 'react';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { useLocation, useNavigate } from 'react-router-dom';
import SalesGrid from './salesGrid';
import sales from '../../../src/assets/img/crm_home/main-content/sales.png';
import invoice from '../../../src/assets/img/crm_home/main-content/invoice.png';
import InvoiceGrid from './invoice/invoiceGrid';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { getGridDataByModuleKey } from '../../redux/selector';
import { invoiceInputData, salesOrderInputData } from '../../shared/constants';
import { useSelector } from 'react-redux';
import Loader from '../../shared/component/Loader';

export const Sales = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const location = useLocation();
  const navigate = useNavigate();
  const [isTabActive, setIsTabActive] = useState('salesOrder');
  const gridDataSalesOrder = useSelector(getGridDataByModuleKey('salesOrder'));
  const gridDataInvoice = useSelector(getGridDataByModuleKey('invoice'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.pathname.includes('/invoice')) {
      setIsTabActive('invoice');
    } else if (location.pathname.includes('/sales/salesOrder')) {
      setIsTabActive('salesOrder');
    }
  }, [location.pathname]);

  const handleIsTabActive = (tab) => {
    if (tab === 'salesOrder' && location.pathname !== '/sales/salesOrder') {
      navigate('/sales/salesOrder');
    } else if (tab === 'invoice' && location.pathname !== '/sales/invoice') {
      navigate('/sales/invoice');
    }
    setIsTabActive(tab);
  };

  const handleCreateInvoice = () => {
    navigate('/sales/createInvoice');
  };

  const handleCreateSales = () => {
    navigate('/sales/createSalesOrder');
  };

  const exportAllSales = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...salesOrderInputData,
        pageSize: gridDataSalesOrder?.totalCount,
        searchText: gridDataSalesOrder?.inputPayload?.searchText ? gridDataSalesOrder?.inputPayload?.searchText : null,
        filterJson: gridDataSalesOrder?.inputPayload?.filterJson ? gridDataSalesOrder?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllSales(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'SalesOrders.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting SalesOrders:', error);
        setLoading(false);
      }
    };

    const exportAllInovice = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...invoiceInputData,
        pageSize: gridDataInvoice?.totalCount,
        searchText: gridDataInvoice?.inputPayload?.searchText ? gridDataInvoice?.inputPayload?.searchText : null,
        filterJson: gridDataInvoice?.inputPayload?.filterJson ? gridDataInvoice?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllInvoice(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Invoices.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting Invoices:', error);
        setLoading(false);
      }
    };

  return (
    <>{loading && <Loader/>}
      <div className="inner-page" style={containerStyle}>
        <div id="crm-sales-page">
          <div className="dash-container">
            <div className="tbl_container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="main-hd tabP">
                    <div className="mob">
                      <div className="pagetitle ">
                        <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                        {isTabActive === 'salesOrder' ? 'Sales Order' : 'Invoice'}
                      </div>
                    </div>
                    <div className="dsk">
                      <div className="pagetitle tabLeft">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                          <button
                            className={`nav-link ${isTabActive === 'salesOrder' ? 'active' : ''}`}
                            id="campaigns-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#campaigns"
                            type="button"
                            role="tab"
                            aria-controls="campaigns"
                            aria-selected="true"
                            onClick={() => {
                              handleIsTabActive('salesOrder');
                            }}
                          >
                            <img src={sales} alt="sales" />
                            Sales Order
                          </button>
                          <button
                            className={`nav-link ${isTabActive === 'invoice' ? 'active' : ''}`}
                            id="smartSq-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#smartSq"
                            type="button"
                            role="tab"
                            aria-controls="smartSq"
                            aria-selected="true"
                            onClick={() => {
                              handleIsTabActive('invoice');
                            }}
                          >
                            <img src={invoice} alt="invoice" />
                            Invoice
                          </button>
                        </div>
                      </div>
                    </div>
                    {isTabActive === 'salesOrder' ? (
                      <>
                        <div className="third-div mobView tabAction">
                          <div className="dsk">
                            <GlobalSearch moduleName={'salesOrder'} />
                          </div>
                          <button
                            className="btn btn-outline-primary mobOption export-btn"
                            type="button"
                            onClick={exportAllSales}
                          >
                            <svg
                              width="16px"
                              height="16px"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                                fill="#333333"
                              />
                              <path
                                d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                                stroke="#333333"
                                strokeWidth="2"
                              />
                            </svg>{' '}
                            <div className="dsk"> Export</div>
                          </button>

                          <button
                            className="btn btn-primary createTkt"
                            type="button"
                            onClick={handleCreateSales}
                          >
                            Create Sales Order
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="third-div mobView tabAction">
                          <div className="dsk">
                            <GlobalSearch moduleName={'invoice'} />
                          </div>
                          <button
                            className="btn btn-outline-primary mobOption export-btn"
                            type="button"
                            onClick={exportAllInovice}
                          >
                            <svg
                              width="16px"
                              height="16px"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                                fill="#333333"
                              />
                              <path
                                d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                                stroke="#333333"
                                strokeWidth="2"
                              />
                            </svg>{' '}
                            <div className="dsk"> Export</div>
                          </button>

                          <button
                            className="btn btn-primary createTkt"
                            type="button"
                            onClick={handleCreateInvoice}
                          >
                            Create Invoice
                          </button>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="mob mb-3">
                    <GlobalSearch moduleName={'campaignList'} />
                  </div>
                  <div className="mob my-2 tabMob">
                    <div className="pagetitle tabLeft">
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className={`nav-link ${isTabActive === 'salesOrder' ? 'active' : ''}`}
                          id="campaigns-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#campaigns"
                          type="button"
                          role="tab"
                          aria-controls="campaigns"
                          aria-selected="true"
                          onClick={handleIsTabActive}
                        >
                          <img src={sales} alt="sales" />
                          Sales Order
                        </button>
                        <button
                          className={`nav-link ${isTabActive === 'invoice' ? 'active' : ''}`}
                          id="smartSq-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#smartSq"
                          type="button"
                          role="tab"
                          aria-controls="smartSq"
                          aria-selected="true"
                          onClick={handleIsTabActive}
                        >
                          <img src={invoice} alt="invoice" />
                          Invoice
                          {/* {isTabActive} */}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="tabPage">
                    <div className="tab-content">
                      {isTabActive === 'salesOrder' ? (
                        <div>
                          <SalesGrid />
                        </div>
                      ) : (
                        <div>
                          <InvoiceGrid />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sales;
